import { Box, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useGetBankAccountTypes from '../../hooks/useGetBankAccountTypes';
import useGetBanks from '../../hooks/useGetBanks';
import { onRefresh } from '../../utils/refreshPage';
import { ButtonsPrimary, ButtonsTertiary } from '../ComponentApp/buttoms/ButtonsXcala';
import Spinner from '../Spinner';
import ModalErrorFetch from '../UI/ModalErrorFetch';
import {
  ButtonsAcount,
  CardContent,
  CardContentAvatar,
  DivisionSectionFrom,
  SectionInteractive,
  TextCuent,
} from '../XcalaComponents/DivisionSectionFrom';
import { InputSelectBank } from './InputSelectBank';

export const FormBankSection = ({
  isEditBankData,
  bankField,
  setIsEditBankData,
  isBankData,
  loadingUserBank,
  handleEditWithoutBankData,
  handleOpenEditBankData,
  handleChangeBankFields,
  errorRegisterUserBank,
  loadingRegisterUserBank,
  accountNumberError,
  handleUpdateData,
  handleDefaultData,
  errorPhone,
  errorAddress,
}) => {
  const navigate = useNavigate();

  const { data, error: errorGetBanks, loading: loadingGetBanks } = useGetBanks();

  const {
    data: dataBankTypes,
    error: errorGetBankAccountTypes,
    loading: loadingGetBankAccountTypes,
  } = useGetBankAccountTypes();

  const successGetBankAccountTypes = dataBankTypes?.getBankAccountTypes;
  const successGetBanks = data?.getBanks;

  const handleChangePassword = () => {
    navigate('/changepassword');
  };

  if (loadingUserBank || loadingGetBanks || loadingGetBankAccountTypes) {
    return <Spinner />;
  }

  if (errorGetBanks || errorGetBankAccountTypes || errorRegisterUserBank) {
    return (
      <ModalErrorFetch
        message='Me temo que tendras que hacerlo de nuevo.... algo salio mal'
        error={errorGetBanks || errorGetBankAccountTypes || errorRegisterUserBank}
        refresh={onRefresh}
      />
    );
  }

  return (
    <SectionInteractive sx={{ width: { xs: '90%', md: '30%' } }}>
      <CardContent>
        <DivisionSectionFrom
          isEdit={isEditBankData}
          setIsEdit={setIsEditBankData}
          handleOpenEdit={handleOpenEditBankData}
          textTitle={'Datos Bancarios'}
          handleUpdateData={handleUpdateData}
          handleDefaultData={handleDefaultData}
          errorPhone={errorPhone}
          errorAddress={errorAddress}
          accountNumberError={accountNumberError}
          show
        />

        {loadingRegisterUserBank ? (
          <Spinner />
        ) : isBankData ? (
          <Stack
            sx={{
              gap: '24px',
            }}>
            <InputSelectBank
              isEdit={isEditBankData}
              nameFiled={'Banco'}
              selet={bankField.bankSelected}
              dataBanks={successGetBanks}
              funtion={handleChangeBankFields}
            />
            <InputSelectBank
              isEdit={isEditBankData}
              nameFiled={'Tipo de cuenta'}
              selet={bankField.accountTypeSelected}
              dataBanks={successGetBankAccountTypes}
              funtion={handleChangeBankFields}
            />
            <InputSelectBank
              isEdit={isEditBankData}
              nameFiled={'No. de cuenta'}
              selet={bankField.number}
              funtion={handleChangeBankFields}
              accountNumberError={accountNumberError}
            />
          </Stack>
        ) : (
          <Stack
            sx={{
              gap: '32px',
              marginTop: '0px',
            }}>
            <TextCuent>Aun no registras tu cuenta</TextCuent>
            <ButtonsAcount onClick={handleEditWithoutBankData}>
              <ButtonsTertiary fullWidth name='Agregar mi cuenta' />
            </ButtonsAcount>
          </Stack>
        )}
      </CardContent>

      <CardContentAvatar>
        <Stack
          direction='row'
          gap='28px'
          justifyContent='space-evenly'
          alignItems='center'
          sx={{
            '@media (max-width: 1370px)': {
              flexDirection: 'column',
              alignItems: 'center',
              whiteSpace: 'nowrap',
              justifyContent: 'space-evenly',
              gap: '28px',
              width: '100%',
            },
            '@media (max-width: 1199px) and (min-width: 1040px)': {
              flexDirection: 'column',
              padding: '16px',
              width: '100%',
            },
            '@media (max-width: 1039px)': {
              flexDirection: 'row',
              padding: '16px',
              width: '100%',
            },
            '@media (max-width: 600px)': {
              flexDirection: 'column',
              padding: '16px',
              width: '100%',
            },
          }}>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <img
              alt={'changepassword'}
              src='/assets/images/changepassword.svg'
              style={{
                width: '72px',
                height: '72px',
              }}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}>
            <ButtonsPrimary name='Cambiar contraseña' onClick={handleChangePassword} />
          </Box>
        </Stack>
      </CardContentAvatar>
    </SectionInteractive>
  );
};
